import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { TextVariantProps, Theme } from './types';

const BoldText = styled.span`
    font-weight: 700;
`;

const TextAside = styled.p`
    position: absolute;

    left: 100%;
    top: 50%;
    transform: translateY(-50%);

    margin-inline-start: 12px;
`;

export const TextProgressAside = ({ progress }: TextVariantProps) => {
    return <TextAside>{progress.toFixed(0)}%</TextAside>;
};

const TextInsideContainer = styled.span<{ innerTheme: Theme }>`
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    ${({ innerTheme, theme }) =>
        innerTheme === 'light'
            ? css`
                  color: ${theme.colors.black[700]};
              `
            : css`
                  color: #fff;
              `}
    transform: translate(-50%, -50%);
`;

function timeLeft(seconds?: number) {
    if (!seconds && seconds === 0) return 'Slower than usual...';

    if (!seconds || seconds < 60) return 'est. soon';

    if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        return minutes + ' est. min' + (minutes === 1 ? '' : 's');
    } else {
        const hours = Math.floor(seconds / 3600);
        return hours + ' est. hour' + (hours === 1 ? '' : 's');
    }
}

export const TextProgressInsideWithEstimation = ({ progress, remainingSeconds, theme }: TextVariantProps) => {
    const text = `${progress.toFixed(0)}% `;

    return (
        <TextInsideContainer innerTheme={theme}>
            {<BoldText>{text}</BoldText>}
            {timeLeft(remainingSeconds)}
        </TextInsideContainer>
    );
};
